import React, { useEffect, useState } from "react";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import { styled } from "@mui/material/styles";
import {
  Typography,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  TextField,
  Button,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";

import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import SaveIcon from "@mui/icons-material/Save";
import CloseIcon from "@mui/icons-material/Close";
import DownloadIcon from "@mui/icons-material/Download";
import VisibilityIcon from "@mui/icons-material/Visibility";
import axios from "axios";
// const fileInputRef = useRef(null);
// const editFileInputRef = useRef(null);

import { getUserInfo } from "../Authservice"; // Adjust the path as needed
import { resources } from "../Resourses/Resources";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#2C268A",
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const AdministrationMinutes = () => {
  const [rows, setRows] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [backupRow, setBackupRow] = useState(null);
  const [newData, setNewData] = useState({ MemberName: "", file: null });
  const [selectedFileName, setSelectedFileName] = useState("");
  const [viewDialogOpen, setViewDialogOpen] = useState(false);
  const [currentDocument, setCurrentDocument] = useState({ name: "", url: "" });

  const userRole = getUserInfo()?.roles?.[0] || "";
  const isManagement = userRole === "ROLE_MANAGEMENT";

  const getdataBody = async () => {
    try {
      const response = await axios.get(`${resources.APPLICATION_URL}getAllAcademicBodyMinutes`);
      const formatted = response.data.map((item, index) => ({
        id: item.id || index.toString(),
        MemberName: item.meetingDate || "",
        documentName: item.documentName || "",
        documentPath: item.documentPath || "",
        uniqueKey: item.uniqueKey || "",
      }));
      setRows(formatted);
    } catch (e) {
      console.log("Error fetching academic body minutes:", e);
    }
  };

  const handleAdd = async () => {
    if (!newData.MemberName) {
      alert("Please enter academic year");
      return;
    }

    if (!newData.file) {
      alert("Please choose a file");
      return;
    }


    const jsonBlob = new Blob([JSON.stringify({ meetingDate: newData.MemberName })], {
      type: "application/json",
    });

    const formData = new FormData();
    formData.append("minute", jsonBlob)
    formData.append("file", newData.file);

    try {
      await axios.post(`${resources.APPLICATION_URL}saveAcademicBodyMinutes`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      setNewData({ MemberName: "", file: null });
      setSelectedFileName("");
      await getdataBody();
    } catch (e) {
      console.error("Error uploading file:", e);
      alert("Error uploading file");
    }
  };

  const handleDelete = async (id) => {
    try {
      const response = await axios.delete(`${resources.APPLICATION_URL}deleteAcademicBodyMinutes?id=${id}`)
      alert("Sucessfully deleted")
      getdataBody();


    }
    catch (e) {
      console.log("error", e)
    }
  };

  const handleEdit = (id) => {
    const rowToEdit = rows.find((row) => row.id === id);
    // setBackupRow({ ...rowToEdit });
    setNewData(rowToEdit);
    setEditingId(id);

    // if (editFileInputRef.current) {
    //   editFileInputRef.current.value = "";
    // }
  };


  const handleCancel = () => {
    if (backupRow) {
      setRows((prev) =>
        prev.map((row) => (row.id === backupRow.id ? backupRow : row))
      );
    }
    setEditingId(null);
    setBackupRow(null);
  };


  const handleSave =async () => {
    const jsonBlob = new Blob([JSON.stringify({ ... newData,meetingDate: newData.MemberName })], {
      type: "application/json",
    });

    const formData = new FormData();
    formData.append("minute", jsonBlob)
    formData.append("file", newData.file);

    try {
      await axios.post(`${resources.APPLICATION_URL}saveAcademicBodyMinutes`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      setEditingId(null);
      setBackupRow(null);
      setNewData({MemberName: "", file: null});
      getdataBody();
    }catch(e){
      console.log("error",e)
    }

  };

  const handleChange = (id, field, value) => {
    setRows((prev) =>
      prev.map((row) => (row.id === id ? { ...row, [field]: value } : row))
    );
  };

  // const handleViewDocument = async () => {
  //   const row = {
  //     "documentPath": "C:\\uploadfiles\\Student absent report - 2025-03-042025_04_12_08_56_36.pdf",
  //     "documentName": "Student absent report - 2025-03-042025_04_12_08_56_36.pdf"
  //   }
  //   // setCurrentDocument({
  //   //   name: row.documentName,
  //   //   // url: `${resources.APPLICATION_URL}documents/${row.documentPath}`,
  //   //   url: `${resources.APPLICATION_URL}getFilePathtoConvertBase64?filePath=${encodeURIComponent(row.documentPath)}`
  //   // });
  //   try {



  //     const encodedPath = encodeURIComponent(row.documentPath);


  //     const response = await axios.get(
  //       `${resources.APPLICATION_URL}getFilePathtoConvertBase64?filePath=${encodedPath}`
  //     );


  //     const base64Data = response.data?.base64 || response.data;


  //     const byteCharacters = atob(base64Data);
  //     const byteNumbers = Array.from(byteCharacters).map((char) =>
  //       char.charCodeAt(0)
  //     );
  //     const byteArray = new Uint8Array(byteNumbers);
  //     const pdfBlob = new Blob([byteArray], { type: "application/pdf" });


  //     const blobUrl = URL.createObjectURL(pdfBlob);







  //   } catch (error) {
  //     console.error("Error preparing document for viewing:", error);

  //   }
  //   setViewDialogOpen(true);
  // };
  const handleViewDocument = async (documentPath,documentName) => {
    const row = {
      // "documentPath": "C:\\uploadfiles\\Student absent report - 2025-03-042025_04_12_08_56_36.pdf",
      // "documentName": "Student absent report - 2025-03-042025_04_12_08_56_36.pdf"
      "documentPath":documentPath,
      "documentName":documentName,
    };

    try {
      const encodedPath = encodeURIComponent(row.documentPath);

      const response = await axios.get(
        `${resources.APPLICATION_URL}getFilePathtoConvertBase64?filePath=${encodedPath}`
      );

      console.log("base64",response)

      const base64Data = response.data?.base64 || response.data;

      const byteCharacters = atob(base64Data);
      const byteNumbers = Array.from(byteCharacters).map((char) =>
        char.charCodeAt(0)
      );
      const byteArray = new Uint8Array(byteNumbers);
      const pdfBlob = new Blob([byteArray], { type: "application/pdf" });

      const blobUrl = URL.createObjectURL(pdfBlob);

      // If you want to open it in a new tab
      window.open(blobUrl, '_blank');

      // Or if you want to use a viewer/modal, set the current document state like this:
      // setCurrentDocument({
      //   name: row.documentName,
      //   url: blobUrl
      // });

    } catch (error) {
      console.error("Error preparing document for viewing:", error);
    }

    setViewDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setViewDialogOpen(false);
    setCurrentDocument({ name: "", url: "" });
  };

  const handleDownloadDocument = () => {
    const link = document.createElement("a");
    link.href = currentDocument.url;
    link.download = currentDocument.name;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  useEffect(() => {
    getdataBody();
  }, []);

  return (
    <div>
      {isManagement && (
        <Box
          sx={{
            background: "white",
            maxWidth: 900,
            margin: "auto",
            mt: 2,
            p: 2,
            display: "flex",
            gap: 2,
            flexWrap: "wrap",
            alignItems: "center",
          }}
        >
          <TextField
            // label="meeting date"
            size="small"
            type="date"
            value={newData.MemberName}
            onChange={(e) =>
              setNewData({ ...newData, MemberName: e.target.value })
            }
          />
          <Button variant="outlined" component="label">
            Choose File
            <input
              type="file"
              hidden
              onChange={(e) => {
                const file = e.target.files[0];
                if (file) {
                  setNewData({ ...newData, file });
                  setSelectedFileName(file.name);
                }
              }}
            />
          </Button>
          {selectedFileName && (
            <Typography variant="body2" sx={{ mt: 1 }}>
              Selected File: {selectedFileName}
            </Typography>
          )}
          <Button variant="contained" onClick={handleAdd}>
            Add
          </Button>
        </Box>
      )}

      <TableContainer
        component={Paper}
        sx={{ background: "white", maxWidth: 900, margin: "auto", mt: 3 }}
      >
        <Table aria-label="administration minutes table">
          <TableHead>
            <TableRow>
              <StyledTableCell>S No</StyledTableCell>
              <StyledTableCell>Meeting Date</StyledTableCell>
              <StyledTableCell>Document</StyledTableCell>
              {isManagement && <StyledTableCell>Actions</StyledTableCell>}
            </TableRow>
          </TableHead>

          <TableBody>
            {rows.map((row, index) => {
              const isEditing = editingId === row.id;
              console.log("====>rowss",rows)
              return (
                <StyledTableRow key={row.id}>
                  <StyledTableCell>{index + 1}</StyledTableCell>
                  <StyledTableCell>
                    {isEditing ? (
                      <TextField
                        size="small"
                        value={newData.MemberName}
                        onChange={(e) =>
                          setNewData({ ...newData, MemberName: e.target.value })
                        }

                      />
                    ) : (
                      row.MemberName
                    )}
                  </StyledTableCell>
                  <StyledTableCell>
                    {isEditing ? (
                      <>
                        <Button variant="outlined" component="label" size="small">
                          Choose File
                          <input
                            type="file"
                            hidden
                            onChange={(e) => {
                              const file = e.target.files[0];
                              if (file) {
                                setNewData({ ...newData, file });
                                setSelectedFileName(file.name);
                              }
                            }}
                          />
                        </Button>
                        {selectedFileName && (
                          <Typography variant="body2" sx={{ mt: 1 }}>
                            Selected File: {selectedFileName}
                          </Typography>
                        )}
                      </>
                    ) : (
                      <Button
                        size="small"
                        onClick={() => handleViewDocument(row.documentPath,row.documentName)}
                        startIcon={<VisibilityIcon />}
                      >
                        {/* {row.documentName} */}
                      </Button>
                    )}
                  </StyledTableCell>
                  {isManagement && (
                    <StyledTableCell>
                      {isEditing ? (
                        <>
                          <IconButton
                            onClick={() => handleSave(row.uniqueKey)}
                            color="primary"
                          >
                            <SaveIcon />
                          </IconButton>
                          <IconButton onClick={handleCancel} color="error">
                            <CloseIcon />
                          </IconButton>
                        </>
                      ) : (
                        <>
                          <div>
                            <IconButton
                              onClick={() => handleEdit(row.id)}
                              color="primary"
                            >
                              <EditIcon />
                            </IconButton>
                            <IconButton
                              onClick={() => handleDelete(row.uniqueKey)}
                              color="error"
                            >
                              <DeleteIcon />
                            </IconButton>
                          </div>
                        </>
                      )}
                    </StyledTableCell>
                  )}
                </StyledTableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default AdministrationMinutes;
